import { Resource } from 'i18next';

export const DEFAULT_LOCALE = 'en-US';

/**
 * Checks if a preferred locale is available and returns it if so. Otherwise, it
 * returns the default ('en-US');
 * @param resources The list of resources available.
 * @param preferredLocale The locale the would be preferred.
 * @returns The preferred locale, if available, otherwise the default.
 */
export const getCalculatedLocale = (resources: Resource, preferredLocale: string | undefined) => {
  const hasPreferredLocale = preferredLocale && preferredLocale in resources;

  if (hasPreferredLocale) {
    return preferredLocale;
  }

  return DEFAULT_LOCALE;
};
